import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";

class SearchCard extends React.Component {
    constructor() {
        super();
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.click = this.click.bind(this);
        this.state = { searchText: "" };
    }
    
    handleChange(value) {
        this.setState({ searchText: value });
    }

    handleKeyPress(event) {
        if(event.key == "Enter"){
            this.props.history.push({ pathname: this.props.pathname, state: { searchText: this.state.searchText } });
        }
    }

    click() {
        this.props.history.push({ pathname: this.props.pathname, state: { searchText: this.state.searchText } });
    }

    render() {
        return (
            <Card className={`maintenance-card ${this.props.className || ''}`}>
                <CardHeader
                    title={this.props.title}
                    subheader={this.props.subTitle}
                    avatar={<Avatar><Icon>{this.props.icon}</Icon></Avatar>}
                />
                <Box className="maintenance-card-actions maintenance-card-search">
                    <TextField
                        variant="standard"
                        label={this.props.actionName}
                        placeholder={this.props.actionName}
                        value={this.state.searchText}
                        onChange={(e) => this.handleChange(e.target.value)}
                        onKeyPress={this.handleKeyPress}
                        fullWidth
                        sx={{ flex: 1 }}
                    />
                    <IconButton onClick={this.click} color="primary">
                        <Icon>search</Icon>
                    </IconButton>
                </Box>
            </Card>
        );
    }
}

SearchCard.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    className: PropTypes.string,
    history: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
    actionName: PropTypes.string.isRequired,
};

export default SearchCard;